import React, { useState, useEffect } from "react";
import giftSilver from "../../assets/images/stuff/giftSilver.png";
import giftBlue from "../../assets/images/stuff/giftBlue.png";
import giftBg from "../../assets/images/stuff/giftBg2.png";
import downloadStickers from "../../assets/images/stuff/downloadStickers.png";
import downloadBtn from "../../assets/images/stuff/downloadBtn.png";
import sticker0 from "../../assets/images/stickers/sticker0.png";
import sticker1 from "../../assets/images/stickers/sticker2.png";
import sticker2 from "../../assets/images/stickers/sticker3.png";
import sticker3 from "../../assets/images/stickers/sticker4.png";
import sticker4 from "../../assets/images/stickers/sticker5.png";
import sticker5 from "../../assets/images/stickers/sticker6.png";
import sticker6 from "../../assets/images/stickers/sticker7.png";
import sticker7 from "../../assets/images/stickers/sticker8.png";
import sticker8 from "../../assets/images/stickers/sticker9.png";
import sticker9 from "../../assets/images/stickers/sticker10.png";
import sticker10 from "../../assets/images/stickers/sticker11.png";
import sticker11 from "../../assets/images/stickers/sticker12.png";
// import allStickers from "../../assets/images/stickers/allStickers.svg";
import allStickers from "../../assets/allStickersNew/stickerAll.svg";
import { saveAs } from "file-saver";
import allContent from "../../allContent";

import style from "./Gift.module.css";
import JSZip from "jszip";

const Gift = ({
  item,
  index,
  phase,
  setPhase,
  setOpenVideo,
  setVideo,
  setShowDialog,
  setDialogContent,
  seenAll,
}) => {
  const [contentStyle, setContentStyle] = useState(null);
  const [firstStateOfPhase, setFirstStateOfPhase] = useState(0);

  useEffect(() => {
    if (firstStateOfPhase === 0) {
      setContentStyle(style.content);
    }
    if (phase === 0 && firstStateOfPhase === 0) {
      setContentStyle(style.content);
      setFirstStateOfPhase(1);
    }
    if (phase === 1 && firstStateOfPhase !== 0) {
      setContentStyle(style.contentShowAll);
    }
    if (phase > 1 && index + 2 === phase && firstStateOfPhase !== 0) {
      setContentStyle(style.contentShowOne);
    }
    if (phase > 1 && index + 2 > phase && firstStateOfPhase !== 0) {
      setContentStyle(style.contentMinimazed);
    }
    if (phase > 1 && index + 2 < phase && firstStateOfPhase !== 0) {
      setContentStyle(style.contentShrinked);
    }
    if (phase === 0 && firstStateOfPhase !== 0) {
      setContentStyle(style.contentMinimazed);
    }
  }, [phase]);

  return (
    <div className={contentStyle}>
      {" "}
      <div
        alt="giftBg"
        className={style.contentBg}
        style={{
          backgroundImage: `url(${giftBg})`,
          backgroundSize: "cover",
          // backgroundPosition: "100% 150%",
          backgroundRepeat: "no-repeat",
          // opacity: index + 2 === phase ? "1" : "0",
          filter: !seenAll ? "brightness(1.5) grayscale(100%)" : "",
        }}
      />
      {phase === 6 && (
        <div
          className={style.text}
          style={{
            opacity: !seenAll ? "0.3" : "0.99",
          }}
        >
          <h2>{allContent.gift.title1}</h2>
          <h1>
            {allContent.gift.title2.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </h1>
          <p>
            {allContent.gift.description1.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
          <br />
          <p>
            {allContent.gift.description2.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
          {/* <p>
            We hope these videos remind you <br />
            of the difference you make. You're a <br />
            true retail hero.
          </p> */}
        </div>
      )}
      {phase === 6 && (
        <div className={style.downloadContainer}>
          <div style={{ position: "relative" }}>
            <img
              src={allStickers}
              alt="downloadStickers"
              className={style.downloadStickers}
              style={{
                opacity: !seenAll ? "0.3" : "0.99",
                width: "100vw",
              }}
            />
            {/* <img
              src={downloadBtn}
              alt="downloadBtn"
              className={style.downloadBtn}
              onPointerDown={() => {
                if (!seenAll) return;
                setDialogContent({
                  type: "download",
                });
                setShowDialog(true);
              }}
              style={{
                filter: !seenAll
                  ? "grayscale(70%) contrast(60%) brightness(1.5)"
                  : "grayscale(0%)",
              }}
            /> */}

            <div className="buttonHolderGift">
              <button
                disabled={seenAll ? false : true}
                onPointerDown={() => {
                  if (!seenAll) return;
                  setDialogContent({
                    type: "download",
                  });
                  setShowDialog(true);
                }}
                className={(() => {
                  switch (true) {
                    case seenAll:
                      return "mainButtonApp buttonTopMargin2";
                    default:
                      return "mainButtonApp buttonGrayBackgound buttonTopMargin2";
                  }
                })()}
              >
                {allContent.gift.button}
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        className={style.contentHeader}
        onPointerUp={() => {
          if (!seenAll) return;
          setPhase(index + 2);
        }}
      >
        <div className={style.contentHeaderText}>
          <div
            className={style.contentHeaderTitle}
            style={{
              opacity: !seenAll ? "0.3" : "0.99",
            }}
          >
            {item.title}
          </div>
        </div>
        <div className={style.contentHeaderImages}>
          <img
            src={item.stickers[0]}
            alt="sticker"
            style={{
              opacity: !seenAll ? "0.3" : "0.99",
              width: "58px",
            }}
          />
          <div
            className={
              // todayTimestamp > item.timestamp
              style.contentHeaderWeek
              // : style.contentHeaderWeekDark
            }
          >
            {/* <div
              className={style.blueGradient}
              style={{
                opacity: item.seen ? "0" : "0.99",
              }}
            ></div>
            <div
              className={style.yellowGradient}
              style={{
                opacity: !item.seen ? "0" : "0.99",
              }}
            ></div>
            <div
              className={style.silverGradient}
              style={{
                opacity: todayTimestamp > item.timestamp ? "0" : "0.99",
              }}
            ></div> */}
            <img src={seenAll ? giftBlue : giftSilver} alt="giftSilver" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gift;
